import {
  LineChart as LineChartPrimitive,
  Line,
  ResponsiveContainer,
  XAxis,
  YAxis,
  Tooltip,
} from 'recharts';
import { Text, textVariantClasses } from '@/components/ui/Text';
import clsx from 'clsx';

interface LineChartProps {
  data?: { week: string; value: number }[];
  unit?: string;
}

const defaultData = [
  { week: '1', value: 10 },
  { week: '2', value: 20 },
  { week: '3', value: 10 },
  { week: '4', value: 30 },
  { week: '5', value: 40 },
  { week: '6', value: 50 },
  { week: '7', value: 20 },
  { week: '8', value: 10 },
];

export function LineChart({ data = defaultData, unit = 'tickets' }: LineChartProps) {
  return (
    <ResponsiveContainer width="100%" height={300} className="mt-md">
      <LineChartPrimitive data={data} margin={{ left: 40, right: 40, bottom: 10, top: 10 }}>
        <Line dataKey="value" strokeWidth={2} stroke="#2FD181" type="linear" />
        <XAxis
          dataKey="week"
          stroke="#8897AE"
          tickMargin={8}
          tick={({ x, y, payload }) => {
            return (
              <g transform={`translate(${x},${y})`}>
                <text
                  x={0}
                  y={0}
                  textAnchor="middle"
                  className={clsx(textVariantClasses['label-2xs-strong'], 'fill-neutral-default')}
                >
                  <tspan x={0} dy={10}>
                    {payload.value}
                  </tspan>
                </text>
              </g>
            );
          }}
        />
        <YAxis
          width="auto"
          stroke="#8897AE"
          tickMargin={8}
          tick={({ x, y, payload }) => {
            return (
              <g transform={`translate(${x},${y})`}>
                <text
                  x={0}
                  y={0}
                  dy={2.5}
                  textAnchor="end"
                  className={clsx(textVariantClasses['label-2xs-strong'], 'fill-neutral-default')}
                >
                  {payload.value}
                </text>
              </g>
            );
          }}
        />
        <Tooltip
          content={({ active, payload, label }) => {
            if (active && payload && payload.length) {
              return (
                <div className="bg-base-white border-transparent-dark-12 p-xs rounded-md border shadow-xs">
                  <Text variant="label" size="xs" className="text-neutral-muted mb-4xs">
                    {label}
                  </Text>
                  <Text variant="label" size="xs" strong>
                    {payload[0].value} {unit}
                  </Text>
                </div>
              );
            }
            return null;
          }}
        />
      </LineChartPrimitive>
    </ResponsiveContainer>
  );
}
